import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_CONSTANT } from '../../constants/application.constant';
import { StorageService } from '../../services/storage/storage.service';
import { SsoService } from '../../services/sso/sso.service';
import { Subscription } from 'rxjs';
import { SpinnerService } from '../../services/spinner/spinner.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  showLoginPage: boolean = false;
  userInfo: any;
  private subscriptions = new Subscription()

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private ssoService: SsoService,
    private readonly spinnerService: SpinnerService,
    private snackbarService: SnackbarService
  ) {
    this.navigationEvents();
  }
  ngOnInit(): void {
    
  }

  navigationEvents(): void {
    const routerSubscription = this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          const id = this.route.snapshot.queryParams[APP_CONSTANT.ID];
          if (id) {
            if (this.isNumeric(id))
              this.storageService.store(APP_CONSTANT.ID, this.route.snapshot.queryParams[APP_CONSTANT.ID]);
            else 
              return this.snackbarService.error("Please provide a valid id.");
          } 

          const savedId = this.storageService.retrieve(APP_CONSTANT.ID);
          if (savedId) {
            this.storageService.store(APP_CONSTANT.Code, this.route.snapshot.queryParams[APP_CONSTANT.Code]);
            const code = this.storageService.retrieve(APP_CONSTANT.Code);
            this.storageService.delete(APP_CONSTANT.Code);
            const codeChallenge = this.storageService.retrieve(APP_CONSTANT.Code_Challenge);
            const token = this.ssoService.retrieveToken();
            if (!code && !codeChallenge && !token) {
              const relogin = this.storageService.retrieve(APP_CONSTANT.Relogin);
              if (relogin) {
                this.storageService.store(APP_CONSTANT.Relogin, false);
                this.loginPage();
              } else {
                this.showLoginPage = true;
                this.loginPage();
              }
            } else if (code) {
              this.storageService.store(APP_CONSTANT.Code, code);
              this.getAuthToken();
            } else if (codeChallenge && token) {
              this.getUserInfo();
            } else {
              this.ssoService.logout();
            }
          } else {
            this.snackbarService.error("Can not find invite id. Please provide a valid id.");
            //this.ssoService.logout();
          }
        }
      }
    );
    this.subscriptions.add(routerSubscription);
  }

  loginPage() {
    const token = this.ssoService.retrieveToken();
    if (token) {
      this.getUserInfo();
    } else {
      const code_verifier = this.ssoService.randomString();
      this.ssoService.generateCodeChallenge(code_verifier).then(challenge => {
        const code_challenge = challenge;
        this.storageService.store(APP_CONSTANT.Code_Verifier, code_verifier);
        this.storageService.store(APP_CONSTANT.Code_Challenge, code_challenge);
        const authUrl = this.ssoService.getAuthUrl(code_challenge);
        window.location.href = authUrl;
      }).catch(err => {
        console.log(err);
        this.snackbarService.error(err?.errorMessage);  
        this.ssoService.logout();
        this.snackbarService.error(err?.errorMessage);
      });
    }
  }

  getAuthToken() {
    this.spinnerService.show();
    const apiSubscription = this.ssoService.getAuthToken().subscribe(
      {
        next: (res: any) => {
          const token = JSON.parse(JSON.stringify(res));
          console.log("token", token);
          this.storageService.store(APP_CONSTANT.Token, token);
          this.getUserInfo();
        },
        error: (e: any) => {
          console.log(e);
          this.snackbarService.error(e?.errorMessage);
          this.spinnerService.hide();
          this.snackbarService.error(e?.errorMessage);
          this.ssoService.logout();
        }
      }
    );
    this.subscriptions.add(apiSubscription);
  }


  getUserInfo() {
    this.spinnerService.show();
    const apiSubscription = this.ssoService.getSsoInviteLocation().subscribe(
      {
        next: (res: any) => {
          console.log("res", res);
          if (res.location) {
            this.spinnerService.hide();
            window.location = res.location;
          } else {
            this.snackbarService.error('Invalid SSO Invite Url');
            this.ssoService.ohidLogout();
            this.spinnerService.hide();
          }
        },
        error: (e: any) => {
          this.snackbarService.error(e?.errorMessage);
          this.ssoService.ohidLogout();
          this.spinnerService.hide();
          this.snackbarService.error(e?.errorMessage);
        }
      }
    );
    this.subscriptions.add(apiSubscription);
  }

  isNumeric(str: number): boolean {
    return !isNaN(str);
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
